/**
 * This is a polyfill library that enables IE 11 to run modern websites
 * Do not use Babel as it conflicts with Google Maps API library
 */
// import "core-js/stable";
import 'regenerator-runtime/runtime';

window.Vue = require('vue').default;
import Slick from 'vue-slick-carousel'
import VueEasyLightbox from 'vue-easy-lightbox'
Vue.use(VueEasyLightbox)

Vue.component('app-header', () => import('./components/Header'));
Vue.component('app-slideshow-gallery', () => import('./components/SliderGallery'));
Vue.component('app-map', () => import('./components/Map'));
Vue.component('app-gallery', () => import('./components/Gallery'));
Vue.component('app-tabs', () => import('./components/Tabs'));
Vue.component('app-collapsible', () => import('./components/Collapsible'));
Vue.component('product-gallery', () => import('./components/ProductGallery'));

const app = new Vue({
  el: '#app',

  components: { Slick },

  data: () => ({
    isLoaded: false,
  }),

  mounted () {
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        this.isLoaded = true
      }
    }
  },

  methods: {}
});

// toggle faq on services
const faq = document.querySelectorAll('.faq-module article')
faq.forEach(function(el){
  el.addEventListener('click', function () {
    this.classList.toggle('active')
  });
});
